import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-search',
  imports: [],
  templateUrl: './search.html',
  styleUrl: './search.scss',
})
export class Search {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
